module.exports = __webpack_public_path__ + "assets/img/carousel_jf15.9f4ab4ad.png";